module.exports = __webpack_public_path__ + "static/media/professional-teaching-banner1.f9fbb371.png";